<ion-card (click)="navigateToPerformancesPage()">
  <div class="header-row">
    <div class="header-text">
      <b>Volgende voorstelling</b><br>
      @if (this.isLoading) {
        <ion-spinner color="primary" name="crescent" />
      }
      @if (this.performance) {
        {{ this.performance?.datetime | date:'EEEE':'CEST':'nl-NL' | titlecase }}
        {{ this.performance?.datetime | date:'d MMMM y':'CEST':'nl-NL' }}
        om {{ this.performance?.datetime | date:'HH:mm':'CEST':'nl-NL' }}
      }
      @if (!this.performance && !this.isLoading) {
        Onbekend
      }
    </div>

    <!-- Quick access to the rehearsal preparation for the upcoming
    performance. Pinned to the top-right via absolute positioning so
    the title + datetime stay centred in the card. -->
    @if (hasRehearsal()) {
      <ion-button
        (click)="openRehearsalModal($event)"
        size="small"
        class="rehearsal-icon-button"
        aria-label="Bekijk repetitie">
        <ion-icon name="accessibility-outline" slot="icon-only" />
      </ion-button>
    }
  </div>

  <!-- Stop clicks inside the rehearsal-url section so Kopieer/WhatsApp/Invullen
  don't bubble up and trigger the card's navigate-to-performances handler.
  Only rendered when the active show opts into the rehearsal feature. -->
  @if (performance?.show?.hasRehearsals) {
    <div (click)="$event.stopPropagation()">
      <app-rehearsal-url [performance]="performance" />
    </div>
  }
</ion-card>

